{
  "common": {
    "ok": "OK",
    "cancel": "Abbrechen",
    "save": "Speichern",
    "delete": "Löschen",
    "edit": "Bearbeiten",
    "close": "Schließen",
    "loading": "Laden...",
    "error": "Fehler",
    "info": "Information",
    "success": "Erfolg",
    "back": "Zurück",
    "send": "Senden",
    "sending": "Wird gesendet...",
    "search": "Suchen",
    "accept": "Akzeptieren",
    "reject": "Ablehnen",
    "confirm": "Bestätigen",
    "online": "Online",
    "you": "Du",
    "noMessages": "Noch keine Nachrichten",
    "adminPanelDesktopOnly": "Panel nicht auf dem Handy",
    "adminPanelDesktopOnlyHint": "Admin- und Organizer-Panel sind auf Tablet und Desktop verfügbar.",
    "networkError": "Daten konnten nicht geladen werden.",
    "networkErrorHint": "Überprüfe deine Verbindung und versuche es erneut.",
    "retry": "Erneut versuchen",
    "myQrCode": "Mein QR-Code",
    "myQrPill": "Mein QR",
    "hideQrPill": "Mein QR ausblenden",
    "showQrPill": "Mein QR anzeigen",
    "today": "Heute",
    "tomorrow": "Morgen"
  },
  "auth": {
    "login": {
      "title": "Willkommen zurück",
      "subtitle": "Anmelden",
      "credentialsHint": "Gib deine Anmeldedaten ein, um fortzufahren",
      "email": "E-Mail-Adresse",
      "emailPlaceholder": "deine@email.com",
      "password": "Passwort",
      "passwordPlaceholder": "••••••••",
      "loading": "Anmeldung läuft...",
      "button": "Anmelden",
      "forgotPassword": "Passwort vergessen?",
      "forgotPasswordSoon": "Demnächst verfügbar",
      "forgotPasswordMessage": "Die Passwort-Wiederherstellung wird bald verfügbar sein.",
      "continueWith": "oder weiter mit",
      "noAccount": "Noch kein Konto?",
      "createAccount": "Konto erstellen",
      "errors": {
        "emailNotConfirmed": "Anmeldung nicht möglich.\n\nWenn du dein Konto gerade erstellt hast, versuche es in ein paar Sekunden erneut.",
        "loginError": "Anmeldefehler",
        "unexpectedError": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut."
      }
    },
    "register": {
      "title": "Tritt BIAVENT bei",
      "subtitle": "Konto erstellen",
      "email": "E-Mail-Adresse",
      "emailPlaceholder": "deine@email.com",
      "password": "Passwort",
      "confirmPassword": "Passwort bestätigen",
      "loading": "Konto wird erstellt...",
      "button": "Konto erstellen",
      "continueWith": "oder weiter mit",
      "hasAccount": "Bereits ein Konto?",
      "loginLink": "Anmelden",
      "success": {
        "title": "✅ Konto erfolgreich erstellt!",
        "message": "Du kannst dich jetzt anmelden. Lass uns dein Profil vervollständigen."
      },
      "errors": {
        "createError": "Fehler beim Erstellen des Kontos",
        "unexpectedError": "Unerwarteter Fehler"
      }
    },
    "logout": {
      "button": "Abmelden",
      "confirm": "Bist du sicher, dass du dich abmelden möchtest?"
    },
    "forgotPassword": {
      "title": "Passwort-Wiederherstellung",
      "subtitle": "Passwort zurücksetzen",
      "description": "Gib deine E-Mail-Adresse ein und wir senden dir einen Link zum Zurücksetzen deines Passworts.",
      "email": "E-Mail",
      "emailPlaceholder": "deine@email.com",
      "loading": "Wird gesendet...",
      "button": "Link senden",
      "backToLogin": "Zurück zur Anmeldung",
      "success": {
        "title": "E-Mail prüfen",
        "message": "Wenn ein Konto mit dieser E-Mail existiert, erhältst du einen Link zum Zurücksetzen deines Passworts."
      },
      "errors": {
        "unexpectedError": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut."
      }
    },
    "resetPassword": {
      "title": "Neues Passwort",
      "subtitle": "Neues Passwort wählen",
      "description": "Gib dein neues Passwort ein und bestätige es.",
      "password": "Neues Passwort",
      "passwordPlaceholder": "••••••••",
      "confirmPassword": "Passwort bestätigen",
      "confirmPasswordPlaceholder": "••••••••",
      "loading": "Wird aktualisiert...",
      "button": "Passwort aktualisieren",
      "backToLogin": "Zurück zur Anmeldung",
      "requirements": {
        "minLength": "Mindestens 8 Zeichen",
        "lowercase": "Mindestens ein Kleinbuchstabe",
        "uppercase": "Mindestens ein Großbuchstabe",
        "number": "Mindestens eine Zahl",
        "symbol": "Mindestens ein Symbol"
      },
      "success": {
        "title": "Passwort aktualisiert",
        "message": "Dein Passwort wurde erfolgreich aktualisiert."
      },
      "invalidLink": {
        "title": "Ungültiger oder abgelaufener Link",
        "message": "Dieser Link zum Zurücksetzen ist ungültig oder abgelaufen. Bitte fordere einen neuen an.",
        "cta": "Neuen Link anfordern"
      },
      "errors": {
        "unexpectedError": "Ein unerwarteter Fehler ist aufgetreten. Bitte versuche es erneut."
      }
    }
  },
  "onboarding": {
    "personalInfo": {
      "title": "Persönliche Angaben",
      "subtitle": "Vervollständige dein Basisprofil",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "phone": "Telefon",
      "email": "E-Mail",
      "placeholderFirstName": "Dein Vorname",
      "placeholderLastName": "Dein Nachname",
      "placeholderPhone": "+34 600 000 000",
      "placeholderEmail": "deine@email.com",
      "continue": "Weiter",
      "errorFirstName": "Vorname ist erforderlich",
      "errorLastName": "Nachname ist erforderlich",
      "errorPhone": "Bitte gib eine gültige Telefonnummer ein",
      "errorEmail": "Bitte gib eine gültige E-Mail ein"
    },
    "socialNetworks": {
      "title": "Soziale Netzwerke (Wähle eines oder mehrere)",
      "linkedin": "LinkedIn",
      "instagram": "Instagram",
      "twitter": "X (Twitter)",
      "youtube": "YouTube",
      "tiktok": "TikTok",
      "placeholderLinkedin": "https://linkedin.com/in/dein-profil",
      "placeholderInstagram": "https://instagram.com/dein-nutzer",
      "placeholderTwitter": "https://twitter.com/dein-nutzer",
      "placeholderYoutube": "https://youtube.com/@dein-kanal",
      "placeholderTiktok": "https://tiktok.com/@dein-nutzer",
      "errorInvalid": "Bitte gib eine gültige URL ein"
    },
    "welcomeQuestion": {
      "title": "Womit beschäftigst du dich?",
      "subtitle": "Deine Antwort hilft uns, Networking-Schlüsselwörter zu generieren und dir relevante Kontakte innerhalb der Veranstaltung vorzuschlagen.",
      "placeholder": "z.B.: Ich bin Frontend-Entwickler, arbeite im Digital Marketing, bin Unternehmer...",
      "continue": "Weiter",
      "back": "Zurück",
      "loading": "Wird verarbeitet...",
      "error": "Wir konnten deine Antwort nicht verarbeiten. Bitte versuche es erneut.",
      "errorEmpty": "Schreib etwas über dich, um fortzufahren"
    }
  },
  "appTour": {
    "replayButton": "Tutorial erneut ansehen",
    "welcome": {
      "title": "Willkommen bei Biavent!",
      "subtitle": "Eine kurze Tour durch das Wichtigste zum Start.",
      "start": "Tour starten",
      "skip": "Jetzt überspringen"
    },
    "controls": {
      "prev": "Zurück",
      "next": "Weiter",
      "skip": "Tutorial überspringen",
      "close": "Schließen",
      "done": "Fertig",
      "progress": "{{current}} von {{total}}",
      "tapHere": "Hier tippen"
    },
    "steps": {
      "navOverview": {
        "title": "Navigation",
        "body": "Hier erreichst du die Hauptbereiche der App."
      },
      "eventsHome": {
        "title": "Deine Events",
        "body": "Sieh kommende Events und deine persönliche Begrüßung."
      },
      "eventsDiscover": {
        "title": "Events entdecken",
        "body": "Hier erscheinen alle Veranstaltungen."
      },
      "navNetworking": {
        "title": "Networking",
        "body": "Tippe hier für Verbindungen und Chats."
      },
      "networkingHub": {
        "title": "Aktivität & Verbindungen",
        "body": "Verwalte Anfragen, Kontakte und Gespräche."
      },
      "navProfile": {
        "title": "Dein Profil",
        "body": "Tippe, um dein berufliches Profil zu bearbeiten."
      },
      "profileComplete": {
        "title": "Profil vervollständigen",
        "body": "Je vollständiger dein Profil ist, desto bessere Empfehlungen können wir dir geben."
      },
      "qrEssential": {
        "title": "Dein QR-Code",
        "body": "Zeige deinen QR auf Events, um sofort zu vernetzen."
      }
    }
  },
  "admin": {
    "title": "Administración",
    "eventos": "Eventos",
    "usuarios": "Usuarios",
    "organizaciones": "Unternehmen",
    "permisos": "Permisos",
    "rankings": "Rankings",
    "encuentros": "Treffen",
    "informes": "Informes y Métricas",
    "notificaciones": "Notificaciones",
    "dashboard": "Dashboard",
    "dashboardTitle": "Dashboard",
    "dashboardSubtitle": "Plattformübersicht",
    "dashboardKpiEvents": "Veranstaltungen gesamt",
    "dashboardKpiUsers": "Benutzer gesamt",
    "dashboardKpiOrganizations": "Unternehmen",
    "dashboardKpiUpcoming": "Kommende Veranstaltungen",
    "dashboardKpiPublished": "Veröffentlicht",
    "dashboardKpiDraft": "Entwürfe",
    "dashboardKpiPast": "Beendet",
    "dashboardKpiCancelled": "Abgesagt",
    "dashboardUpcomingEvents": "Kommende Veranstaltungen",
    "dashboardQuickActions": "Schnellaktionen",
    "dashboardViewEvents": "Veranstaltungen anzeigen",
    "dashboardViewUsers": "Benutzer anzeigen",
    "dashboardViewOrganizations": "Unternehmen anzeigen",
    "dashboardViewReports": "Berichte anzeigen",
    "dashboardViewNotifications": "Benachrichtigungen anzeigen",
    "dashboardNewEvent": "Neue Veranstaltung",
    "dashboardNoUpcoming": "Keine kommenden Veranstaltungen",
    "dashboardEventDate": "Datum",
    "dashboardLoading": "Übersicht wird geladen...",
    "nuevoEvento": "Nuevo Evento",
    "organizacionesTitle": "Unternehmen",
    "organizacionesSubtitle": "Unternehmen der Plattform verwalten",
    "permisosTitle": "Permisos de organizador",
    "permisosSubtitle": "Organisator-Rolle zuweisen oder entfernen und Benutzer Unternehmen zuordnen",
    "crearOrganizacion": "Unternehmen erstellen",
    "crearOrganizacionHint": "Das Unternehmen wird mit Ihrem Benutzer als Inhaber und Organisator erstellt.",
    "asignarOrganizador": "Asignar como organizador",
    "seleccionarOrganizacion": "Unternehmen auswählen",
    "sinOrganizacionesPermisos": "Erstellen Sie ein Unternehmen unter dem Tab Unternehmen, um zuzuweisen.",
    "quitarOrganizador": "Quitar rol organizador",
    "asociarAOrganizacion": "Asociar a organización",
    "nombreOrganizacion": "Nombre",
    "miembros": "Miembros",
    "propietario": "Propietario",
    "sinOrganizaciones": "Keine Unternehmen",
    "gestionarPermisos": "Berechtigungen verwalten",
    "gestionarEquipo": "Team verwalten",
    "equipoTitle": "Team von «{name}»",
    "equipoDescription": "Benutzer zu diesem Unternehmen hinzufügen. Jeder Benutzer kann nur einem Unternehmen angehören.",
    "equipoEmpty": "Keine Mitglieder in diesem Unternehmen",
    "equipoSelectUser": "Benutzer auswählen",
    "equipoSearchUser": "Nach Name oder E-Mail suchen…",
    "equipoSearchMin": "Mindestens 2 Zeichen eingeben",
    "equipoSearchEmpty": "Keine Benutzer gefunden",
    "equipoClearSelection": "Auswahl aufheben",
    "equipoAdd": "Zum Team hinzufügen",
    "rolOrganizador": "Organisator",
    "rolMiembro": "Mitglied",
    "quitarMiembro": "Entfernen",
    "panelScreens": "Panel-Bereiche",
    "panelScreensTitle": "Sichtbare Bereiche im Organisator-Panel",
    "panelScreensDescription": "Aktivieren oder deaktivieren Sie die Bereiche, die Organisatoren dieses Unternehmens sehen.",
    "panelScreenDashboard": "Dashboard",
    "panelScreenEvents": "Veranstaltungen",
    "panelScreenAttendees": "Teilnehmer",
    "panelScreenNetworking": "Networking",
    "panelScreenAnalytics": "Analytics",
    "panelScreenNotifications": "Benachrichtigungen",
    "panelScreenSettings": "Organisationseinstellungen",
    "eliminarEmpresa": "Unternehmen löschen",
    "confirmarEliminarEmpresa": "Unternehmen löschen",
    "confirmarEliminarEmpresaHint": "Unternehmen «{name}» löschen? Mitglieder werden entfernt und Veranstaltungen haben kein zugewiesenes Unternehmen.",
    "panelScreensSave": "Bereiche speichern",
    "panelScreensAll": "Alle",
    "eventosSubtitle": "Verwalte alle Veranstaltungen der Plattform",
    "usuariosSubtitle": "Verwalte Benutzer und Berechtigungen",
    "rankingsSubtitle": "Benutzer-Rankings nach Verbindungen und Aktivität",
    "encuentrosSubtitle": "Persönliche Treffen per QR zwischen verbundenen Nutzern bestätigt",
    "meetups": {
      "loading": "Treffen werden geladen…",
      "kpiTotal": "Gesamt bestätigt",
      "kpi24h": "Letzte 24 Std.",
      "kpi7d": "Letzte 7 Tage",
      "searchPlaceholder": "Nach Name oder E-Mail suchen…",
      "empty": "Noch keine per QR bestätigten Treffen",
      "emptyHint": "Wenn zwei Nutzer ein persönliches Treffen bestätigen, erscheint es hier.",
      "noSearchResults": "Keine Ergebnisse",
      "noSearchResultsHint": "Versuche einen anderen Namen oder eine andere E-Mail.",
      "colUserA": "Nutzer A",
      "colUserB": "Nutzer B",
      "colDate": "Datum",
      "colMethod": "Methode",
      "methodQr": "QR",
      "methodUnknown": "—"
    },
    "informesSubtitle": "Echtzeit-Metriken für kommende Veranstaltungen und vollständige Berichte für vergangene",
    "notificacionesSubtitle": "Sende Benachrichtigungen an alle oder ausgewählte Benutzer",
    "filterOptions": "Filteroptionen",
    "filterAll": "Alle",
    "filterUpcoming": "Kommende",
    "filterPast": "Vergangen",
    "filterCancelled": "Abgesagt",
    "filterAdmins": "Administratoren",
    "filterUsers": "Benutzer",
    "rankingByConnections": "Nach Gesamtverbindungen",
    "rankingMostConnected": "Am meisten verbunden",
    "rankingByConnectionsTitle": "Ranking nach Verbindungen",
    "rankingMostConnectedTitle": "Am meisten verbundene Benutzer",
    "rankingType": "Ranking-Typ",
    "tableTitle": "Titel",
    "tableDate": "Datum",
    "tableLocation": "Ort",
    "tableStatus": "Status",
    "tableActions": "Aktionen",
    "tableName": "Name",
    "tableEmail": "E-Mail",
    "tableRole": "Rolle",
    "tableOrganizer": "Organisator",
    "tablePosition": "Position",
    "tableSent": "Gesendet",
    "tableReceived": "Empfangen",
    "tableAccepted": "Akzeptiert",
    "tableTotal": "Gesamt",
    "tableConnections": "Verbindungen",
    "tableUser": "Benutzer",
    "statusUpcoming": "Kommend",
    "statusPast": "Vergangen",
    "statusCancelled": "Abgesagt",
    "roleAdmin": "Admin",
    "roleUser": "Benutzer",
    "loading": "Laden...",
    "loadingEvents": "Veranstaltungen laden...",
    "loadingUsers": "Benutzer laden...",
    "loadingRankings": "Rankings laden...",
    "noEvents": "Keine Veranstaltungen",
    "noUsers": "Keine Benutzer",
    "noRankings": "Keine Ranking-Daten verfügbar",
    "makeAdmin": "Zum Admin machen",
    "removeAdmin": "Admin entfernen",
    "eventsCount": "Veranstaltungen",
    "usersCount": "Benutzer",
    "confirmDeleteEvent": "Bist du sicher, dass du die Veranstaltung \"{title}\" löschen möchtest? Diese Aktion kann nicht rückgängig gemacht werden.",
    "roleUpdated": "Rolle erfolgreich aktualisiert",
    "roleUpdateError": "Rolle konnte nicht aktualisiert werden",
    "eventDeleted": "Veranstaltung erfolgreich gelöscht",
    "eventDeleteError": "Veranstaltung konnte nicht gelöscht werden",
    "orgCreated": "Organisation erfolgreich erstellt",
    "orgCreateError": "Organisation konnte nicht erstellt werden",
    "dashboardTodayBanner": "{count} eventos comienzan HOY",
    "dashboardPlatformHealth": "Salud de Plataforma",
    "dashboardHealthNewUsers": "Usuarios nuevos (7 días)",
    "dashboardHealthPublishedEvents": "Eventos publicados",
    "dashboardHealthNewOrgs": "Empresas nuevas (7 días)",
    "dashboardDraftPastSummary": "{draft} borradores · {past} finalizados",
    "dashboardBadgeLive": "EN VIVO",
    "dashboardBadgeScheduled": "PROGRAMADO",
    "dashboardViewAllUpcoming": "Ver todos ({count}) →",
    "dashboardNewOrganization": "Nueva Empresa",
    "dashboardViewPermissions": "Ver Permisos"
  },
  "organizer": {
    "title": "Organisatoren-Panel",
    "dashboard": "Dashboard",
    "events": "Veranstaltungen",
    "attendees": "Teilnehmer",
    "networking": "Networking",
    "analytics": "Analytics",
    "notifications": "Benachrichtigungen",
    "settings": "Organisationseinstellungen",
    "loading": "Laden...",
    "selectEvent": "Veranstaltung auswählen",
    "noData": "Keine Daten",
    "noDataDescription": "Daten konnten nicht geladen werden.",
    "dashboardTitle": "Dashboard",
    "dashboardDescription": "Übersicht Ihrer Veranstaltungen und Metriken. Wählen Sie einen Menüpunkt, um zu beginnen.",
    "dashboardLoading": "Übersicht wird geladen...",
    "dashboardKpiTotalEvents": "Events gesamt",
    "dashboardKpiDraft": "Entwürfe",
    "dashboardKpiPublished": "Veröffentlicht",
    "dashboardKpiPast": "Vergangen",
    "dashboardKpiCancelled": "Abgesagt",
    "dashboardKpiTotalAttendees": "Registrierte Teilnehmer",
    "dashboardKpiTotalActiveAttendees": "Aktive Teilnehmer",
    "dashboardNoPublishedHint": "Du hast noch keine veröffentlichten Events. Veröffentliche eines, um Metriken zu sehen.",
    "dashboardKpiTotalConnections": "Erzeugte Verbindungen",
    "dashboardKpiTotalMessages": "Gesendete Nachrichten",
    "dashboardKpiAvgConnections": "Verbindungen pro Event (Durchschnitt)",
    "dashboardKpiAvgProfile": "Profil ausgefüllt (Durchschnitt)",
    "dashboardUpcomingEvents": "Kommende Events",
    "dashboardNoUpcoming": "Keine kommenden Events",
    "dashboardNoUpcomingDescription": "Veröffentliche ein Event, damit es hier erscheint.",
    "dashboardTopNetworking": "Events mit meistem Networking",
    "dashboardTopNetworkingConnections": "Verbindungen",
    "dashboardNoNetworking": "Keine Networking-Daten",
    "dashboardNoNetworkingDescription": "Wenn deine Events Verbindungen erzeugen, erscheinen sie hier.",
    "dashboardCreateEvent": "Event erstellen",
    "dashboardViewAnalytics": "Analytics ansehen",
    "dashboardViewEvents": "Events ansehen",
    "dashboardEmptyTitle": "Du hast noch keine Events",
    "dashboardEmptyDescription": "Erstelle dein erstes Event, um Metriken und Statistiken zu sehen.",
    "dashboardEventDate": "Datum",
    "dashboardEventAttendees": "Teilnehmer",
    "eventsTitle": "Veranstaltungen",
    "eventsNew": "Neue Veranstaltung",
    "eventsFilterStatus": "Status:",
    "eventsFilterAll": "Alle",
    "eventsFilterPublished": "Veröffentlicht",
    "eventsFilterDraft": "Entwurf",
    "eventsFilterPast": "Vergangen",
    "eventsFilterCancelled": "Abgesagt",
    "eventsFilterUpcoming": "Kommende",
    "eventsFilterDate": "Datum:",
    "eventsTableLocation": "Ort",
    "eventsStatusPublished": "Veröffentlicht",
    "eventsStatusDraft": "Entwurf",
    "eventsStatusArchived": "Archiviert",
    "eventsStatusCancelled": "Abgesagt",
    "eventsTableTitle": "Titel",
    "eventsTableDate": "Datum",
    "eventsTableStatus": "Status",
    "eventsTableCapacity": "Kapazität",
    "eventsTableActions": "Aktionen",
    "eventsEdit": "Bearbeiten",
    "eventsCopyLink": "Link kopieren",
    "eventsLinkCopied": "Link kopiert",
    "eventsLanding": "Landing",
    "eventsPublish": "Veröffentlichen",
    "eventsUnpublish": "Zurückziehen",
    "eventsArchive": "Archivieren",
    "eventsCancel": "Veranstaltung absagen",
    "eventsNoEvents": "Keine Veranstaltungen",
    "eventsNoEventsDescription": "Erstellen Sie Ihre erste Veranstaltung, um zu beginnen.",
    "eventsNoCapacity": "Kein Limit",
    "eventNewTitle": "Neue Veranstaltung",
    "eventNewNoOrg": "Sie müssen einer Organisation angehören, um Veranstaltungen zu erstellen. Erstellen Sie zuerst eine Organisation oder bitten Sie darum, als org_admin hinzugefügt zu werden.",
    "eventNewBackToEvents": "Zurück zu Veranstaltungen",
    "eventEditTitle": "Veranstaltung bearbeiten",
    "attendeesTitle": "Teilnehmer",
    "attendeesSendNotification": "Benachrichtigung senden",
    "attendeesNoAttendees": "Keine Teilnehmer",
    "attendeesNoAttendeesDescription": "Noch keine Anmeldungen für diese Veranstaltung.",
    "attendeesLoading": "Teilnehmer laden...",
    "attendeesTableName": "Name",
    "attendeesTableEmail": "E-Mail",
    "attendeesTableStatus": "Status",
    "attendeesTableDate": "Anmeldedatum",
    "attendeesTableProfile": "Profil",
    "networkingTitle": "Networking",
    "networkingLoading": "Metriken laden...",
    "networkingSentRequests": "Gesendete Anfragen",
    "networkingAcceptedRequests": "Akzeptierte Anfragen",
    "networkingTotalConnections": "Verbindungen gesamt",
    "networkingAcceptanceRatio": "Akzeptanzrate",
    "networkingTopConnectors": "Top-Vernetzer",
    "networkingNoData": "Keine Daten",
    "networkingNoDataDescription": "Noch keine Verbindungen zwischen Teilnehmern.",
    "networkingNoDataGeneric": "Metriken konnten nicht geladen werden.",
    "networkingConnections": "Verbindungen",
    "networkingAttendeesCount": "Registrierte Teilnehmer",
    "networkingHintLowEngagement": "Nur ein Teil der Teilnehmer hat Verbindungen geknüpft.",
    "networkingHintCta": "Benachrichtigung senden, um Networking zu fördern",
    "analyticsTitle": "Analytics",
    "analyticsLoading": "Analytics laden...",
    "analyticsRegistered": "Registriert",
    "analyticsActive": "Aktiv",
    "analyticsActiveHelp": "Registrierte, die als «anwesend» markiert sind (Check-in während der Veranstaltung)",
    "analyticsTotalAttendedHelp": "Registrierte, die nach der Veranstaltung als «teilgenommen» markiert wurden",
    "analyticsRegisteredHelp": "Nur Nutzer, die in der App «Anmelden» für diese Veranstaltung geklickt haben (nicht alle Kontoinhaber)",
    "analyticsProfileComplete": "% Profil vollständig",
    "analyticsSentRequests": "Gesendete Anfragen",
    "analyticsAcceptedRequests": "Akzeptierte Anfragen",
    "analyticsTotalConnections": "Verbindungen gesamt",
    "analyticsAcceptanceRatio": "Akzeptanzrate",
    "analyticsMessagesSent": "Gesendete Nachrichten",
    "analyticsActiveConversations": "Aktive Gespräche",
    "analyticsActiveConversationsHelp": "Chats mit mindestens einer Nachricht (Privatchats zwischen Teilnehmern + Event-Chat)",
    "analyticsConnectionsPerAttendee": "Verbindungen pro Teilnehmer (Durchschnitt)",
    "analyticsFunnel": "Trichter",
    "analyticsRegistrationsByDay": "Anmeldungen pro Tag",
    "analyticsDate": "Datum",
    "analyticsRegistrations": "Anmeldungen",
    "analyticsTopInterests": "Top-Interessen",
    "analyticsTopGoals": "Top-Ziele",
    "analyticsShareableSummary": "Teilbare Zusammenfassung",
    "meetups": {
      "sectionTitle": "Bestätigte Treffen",
      "kpiTotal": "Gesamt",
      "kpi24h": "Letzte 24 h",
      "kpi7d": "Letzte 7 Tage",
      "empty": "Noch keine bestätigten Treffen",
      "emptyHint": "Hier erscheinen die persönlichen Treffen der Teilnehmer dieses Events, die sie per Einmal-QR-Code bestätigt haben.",
      "methodQr": "QR",
      "methodUnknown": "—"
    },
    "analyticsCopyClipboard": "In Zwischenablage kopieren",
    "analyticsCopied": "Kopiert",
    "analyticsNoData": "Keine Daten",
    "analyticsNoDataDescription": "Metriken für diese Veranstaltung konnten nicht geladen werden.",
    "analyticsFilterAll": "Alle",
    "analyticsFilterUpcoming": "Bevorstehend",
    "analyticsFilterPast": "Beendet",
    "analyticsEventHeaderViewEvent": "Veranstaltung anzeigen",
    "analyticsEventHeaderCopyLink": "Link kopieren",
    "analyticsEventHeaderViewAttendees": "Teilnehmer anzeigen",
    "analyticsEventHeaderSendNotification": "Benachrichtigung senden",
    "analyticsStatusUpcoming": "Bevorstehend",
    "analyticsStatusOngoing": "Laufend",
    "analyticsStatusPast": "Beendet",
    "analyticsStatusCancelled": "Abgesagt",
    "analyticsSectionAttendance": "Teilnahme und Anmeldung",
    "analyticsSectionNetworking": "Networking und Engagement",
    "analyticsSectionFunnel": "Beteiligungs-Trichter",
    "analyticsSectionSummary": "Teilbarer Überblick",
    "analyticsLastUpdate": "Letzte Aktualisierung",
    "analyticsEmptyNoEvents": "Sie haben noch keine Veranstaltungen",
    "analyticsEmptyNoEventsDescription": "Erstellen Sie Ihre erste Veranstaltung, um Analysen zu sehen.",
    "analyticsEmptyNoRegistrations": "Für diese Veranstaltung haben sich noch keine Teilnehmer angemeldet.",
    "analyticsEmptyNoNetworkingTitle": "Noch keine Networking-Aktivität",
    "analyticsEmptyNoNetworkingCta": "Senden Sie eine Benachrichtigung, um Networking unter Teilnehmern zu aktivieren.",
    "analyticsMetricUnavailable": "Noch keine Daten",
    "analyticsCopySummary": "Überblick kopieren",
    "analyticsFunnelRegistered": "Registriert",
    "analyticsFunnelProfileComplete": "Profil vollständig",
    "analyticsFunnelSentRequest": "Anfrage gesendet",
    "analyticsFunnelConnected": "Vernetzt",
    "analyticsFunnelChatted": "Geplaudert",
    "analyticsTotalRegistered": "Gesamt registriert",
    "analyticsTotalAttended": "Gesamt teilgenommen",
    "analyticsAttendanceRate": "Teilnahmerate",
    "analyticsCancelled": "Abgesagt",
    "analyticsSelectEventPlaceholder": "Veranstaltung wählen",
    "analyticsEmptySelectEvent": "Wählen Sie eine Veranstaltung, um Metriken zu sehen",
    "notificationsTitle": "Benachrichtigungen",
    "notificationsSendToAttendees": "An Teilnehmer der Veranstaltung senden",
    "notificationsTitlePlaceholder": "Titel",
    "notificationsMessagePlaceholder": "Nachricht",
    "notificationsSend": "Senden",
    "notificationsSending": "Wird gesendet...",
    "notificationsHistory": "Kampagnenverlauf",
    "notificationsNoCampaigns": "Keine Kampagnen",
    "notificationsNoCampaignsDescription": "Sie haben noch keine Benachrichtigungen an diese Veranstaltung gesendet.",
    "settingsPageTitle": "Einstellungen",
    "settingsOrgSection": "Organisation",
    "settingsOrgName": "Organisationsname",
    "settingsTeamSection": "Team",
    "settingsTeamRoleAdmin": "Administrator",
    "settingsTeamRoleMember": "Mitglied",
    "settingsTeamRemove": "Aus Team entfernen",
    "settingsRemoveConfirm": "Diesen Benutzer aus dem Team entfernen?",
    "settingsTeamOwner": "Eigentümer",
    "settingsTableName": "Name",
    "settingsTableEmail": "E-Mail",
    "settingsTableRole": "Rolle",
    "settingsSave": "Speichern",
    "settingsSaved": "Gespeichert",
    "settingsLoading": "Laden…",
    "settingsNoOrg": "Sie haben keine Organisation. Erstellen Sie eine im Administrationspanel.",
    "brandingSectionTitle": "Company branding",
    "brandingSectionDesc": "Logo and colors applied to your organization's events.",
    "brandingLogoLabel": "Logo",
    "brandingLogoHint": "Drag an image or click (max. 2 MB)",
    "brandingLogoUpload": "Upload logo",
    "brandingLogoRemove": "Remove logo",
    "brandingUploading": "Uploading…",
    "brandingPrimary": "Primary color",
    "brandingSecondary": "Secondary color",
    "brandingContrastWarning": "Secondary color may have low contrast with white text on badges.",
    "brandingPreviewLabel": "Live preview",
    "brandingSaved": "Branding saved",
    "brandingSaveError": "Could not save branding",
    "brandingUploadError": "Failed to upload logo",
    "plataforma": "Plattform",
    "dashboardKpiRegistered": "Inscritos totales",
    "dashboardKpiAttendance": "Asistencia",
    "dashboardKpiEngagement": "Engagement",
    "dashboardTrendThisWeek": "esta semana",
    "dashboardNextActions": "Próximas acciones",
    "dashboardActionEventsWeek": "{count} eventos comienzan esta semana",
    "dashboardActionPendingCheckIn": "{count} inscritos sin check-in confirmado",
    "dashboardActionConnections": "Revisa las nuevas conexiones en Networking",
    "dashboardMyEvents": "Mis eventos",
    "dashboardAttendeesShort": "inscritos",
    "dashboardBadgeLive": "EN DIRECTO",
    "dashboardBadgeScheduled": "Programado",
    "dashboardQuickActionsTitle": "Acciones",
    "dashboardViewAttendees": "Ver asistentes",
    "dashboardSendNotification": "Enviar notificación",
    "dashboardQuickAnalytics": "Analytics rápido",
    "dashboardExportCsv": "Exportar CSV",
    "dashboardCreateEventShort": "+ Create event",
    "dashboardViewAllEvents": "View all ({count})"
  },
  "panel": {
    "title": "Panel",
    "admin": "Administrationspanel",
    "organizer": "Organisatoren-Panel",
    "desktopOnly": {
      "title": "Verfügbar auf Tablet und Desktop",
      "description": "Die Admin- und Organizer-Panels sind für größere Bildschirme gedacht. Öffne sie auf einem Tablet oder Computer.",
      "backToEvents": "Zurück zu Events"
    }
  },
  "navigation": {
    "eventos": "Veranstaltungen",
    "chats": "Chats",
    "perfil": "Profil",
    "ajustes": "Einstellungen",
    "votacion": "Hilf uns!",
    "quienesSomos": "Über uns",
    "actividad": "Aktivität",
    "closeMenu": "Menü schließen",
    "panel": "Panel",
    "panelAdmin": "Administrationspanel",
    "panelOrganizer": "Organisatoren-Panel"
  },
  "events": {
    "title": "Veranstaltungen",
    "greeting": "Hallo",
    "upcomingEvent": "bevorstehende Veranstaltung",
    "upcomingEvents": "bevorstehende Veranstaltungen",
    "noUpcoming": "Keine bevorstehenden Veranstaltungen",
    "recommendationHint": "Um personalisierte Teilnehmerempfehlungen zu erhalten, registriere dich für Veranstaltungen, die dich interessieren.",
    "recommendationHintShort": "Melde dich für Events an, um personalisierte Empfehlungen zu erhalten.",
    "loading": "Veranstaltungen werden geladen...",
    "hidePast": "Vergangene Veranstaltungen ausblenden",
    "showPast": "Vergangene Veranstaltungen anzeigen",
    "noEvents": "Keine Veranstaltungen",
    "noEventsMessage": "Derzeit sind keine Veranstaltungen geplant. Komm bald wieder, um neue Möglichkeiten zum Vernetzen und Lernen zu entdecken.",
    "live": "LIVE",
    "registered": "Registriert",
    "full": "Ausgebucht",
    "register": "Registrieren",
    "sectionUpcoming": "Kommende Veranstaltungen",
    "sectionPast": "Vergangene Veranstaltungen",
    "filterAll": "Alle",
    "filterRegistered": "Registriert",
    "filterPast": "Vergangen",
    "upcomingBadge": "Demnächst",
    "participants": {
      "zero": "0 Teilnehmer",
      "one": "1 Teilnehmer",
      "many": "{count} Teilnehmer"
    },
    "capacity": {
      "full": "Ausgebucht ({max}/{max})",
      "oneLeft": "{current}/{max} Plätze (1 verfügbar)",
      "available": "{current}/{max} Plätze ({available} verfügbar)"
    }
  },
  "eventDetail": {
    "loading": "Veranstaltung wird geladen...",
    "notFound": "Veranstaltung nicht gefunden",
    "backToEvents": "Zurück zu Veranstaltungen",
    "back": "Zurück",
    "live": "LIVE",
    "description": "Beschreibung",
    "registration": {
      "title": "Anmeldung",
      "subtitle": "Reserviere deinen Platz und erhalte alle notwendigen Informationen zur Teilnahme.",
      "full": "Veranstaltung ausgebucht ({max}/{max} Plätze)",
      "capacity": "{count}/{max} Plätze belegt ({available} verfügbar)",
      "limitedSeats": "Begrenzte Plätze: Bestätige deine Teilnahme, um deinen Platz zu sichern.",
      "pastEvent": "Diese Veranstaltung hat bereits stattgefunden. Schau im Kalender nach neuen Terminen.",
      "alreadyRegistered": "Du bist bereits registriert und erhältst Neuigkeiten zur Veranstaltung.",
      "unregisterLoading": "Anmeldung wird storniert...",
      "unregister": "Von Veranstaltung abmelden",
      "eventFull": "Diese Veranstaltung ist ausgebucht. Keine Plätze verfügbar.",
      "registerLoading": "Dein Platz wird reserviert...",
      "registerButton": "Für Veranstaltung anmelden",
      "checkingRegistration": "Wird überprüft, ob du bereits registriert bist...",
      "loadingProfile": "Dein Profil wird geladen, um die Anmeldung zu aktivieren...",
      "registeredTitle": "Du bist angemeldet!",
      "registeredEmailHint": "Wir senden dir alle Infos per E-Mail"
    },
    "registrationGoal": {
      "title": "Was ist dein Ziel für diese Veranstaltung?",
      "subtitle": "Erzähl uns, was du bei \"{eventTitle}\" suchst, damit wir dir passende Kontakte empfehlen können.",
      "placeholder": "z. B. Mit Entwicklern netzwerken, Investoren finden, neue Technologien lernen...",
      "submit": "Anmelden und Matches berechnen ✨",
      "saveObjective": "Ziel speichern ✨",
      "profileSaveError": "Dein Ziel konnte nicht gespeichert werden. Bitte versuche es erneut.",
      "error": "Bitte schreibe ein Ziel, damit wir dir besser beim Vernetzen helfen können.",
      "tagsTitle": "Schnellvorschläge (mehrere möglich):",
      "tag1": "🤝 Partner oder Mitstreiter finden",
      "tag2": "💼 Geschäftsmöglichkeiten suchen",
      "tag3": "✨ Netzwerken und Kontakte knüpfen",
      "tag4": "📚 Lernen und Wissen aufbauen",
      "tag5": "🚀 Leute aus der Branche kennenlernen"
    },
    "tabs": {
      "agenda": "Programm",
      "speakers": "Referenten",
      "recommendations": "Empfehlungen",
      "notifications": "Benachrichtigungen",
      "location": "Ort"
    },
    "agenda": {
      "title": "Programm",
      "noAgenda": "Kein Programm für diese Veranstaltung verfügbar."
    },
    "speakers": {
      "title": "Referenten",
      "noSpeakers": "Keine Referenten für diese Veranstaltung registriert."
    },
    "recommendations": {
      "recommended": "Empfohlen",
      "allAttendees": "Alle Teilnehmer",
      "title": "Empfohlene Personen",
      "subtitle": "Angemeldete Personen, die dich interessieren könnten.",
      "calculating": "Empfehlungen werden berechnet...",
      "noRecommendations": "Derzeit keine Empfehlungen verfügbar.",
      "attendeesTitle": "Veranstaltungsteilnehmer",
      "attendeesSubtitle": "Personen, die ihre Teilnahme bereits bestätigt haben.",
      "loadingAttendees": "Teilnehmer werden geladen...",
      "beFirst": "Sei die erste Person, die sich für die Veranstaltung registriert.",
      "connect": "Verbinden",
      "requestSent": "Anfrage gesendet",
      "openChat": "Chat öffnen"
    },
    "notifications": {
      "title": "Veranstaltungsbenachrichtigungen",
      "loading": "Benachrichtigungen werden geladen...",
      "noNotifications": "Keine Benachrichtigungen für diese Veranstaltung.",
      "noNotificationsHint": "Benachrichtigungen zu dieser Veranstaltung erscheinen hier.",
      "now": "Jetzt",
      "minutesAgo": "Vor {mins} Min.",
      "hoursAgo": "Vor {hours} Std.",
      "daysAgo": "Vor {days} T.",
      "eventNotification": "Veranstaltungsbenachrichtigung",
      "noMessage": "Keine Nachricht",
      "new": "Neu",
      "markAsRead": "Als gelesen markieren"
    },
    "location": {
      "title": "Ort",
      "openInMaps": "In Google Maps öffnen",
      "notAvailable": "Ort nicht verfügbar",
      "howToArrive": "Wie möchtest du ankommen?",
      "byCar": "Mit dem Auto",
      "byTransit": "Öffentliche Verkehrsmittel",
      "byBicycle": "Mit dem Fahrrad",
      "byWalking": "Zu Fuß",
      "gettingLocation": "Dein Standort wird ermittelt...",
      "cantCalculate": "Route kann ohne gültigen Standort nicht berechnet werden."
    },
    "errors": {
      "profileNotFound": "Wir konnten dein Profil nicht identifizieren. Lade die Seite neu und versuche es erneut.",
      "registrationFailed": "Wir konnten deine Registrierung nicht abschließen. Versuche es in ein paar Sekunden erneut.",
      "registrationError": "Bei der Registrierung ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
      "unregisterConfirm": "Bist du sicher, dass du dich von dieser Veranstaltung abmelden möchtest?",
      "unregisterFailed": "Wir konnten deine Registrierung nicht stornieren. Versuche es in ein paar Sekunden erneut.",
      "unregisterError": "Beim Stornieren deiner Registrierung ist ein Fehler aufgetreten. Bitte versuche es später erneut.",
      "geolocationNotSupported": "Geolokalisierung nicht unterstützt",
      "locationNotAvailable": "Standort nicht verfügbar",
      "locationAccessDenied": "Wir konnten nicht auf deinen Standort zugreifen. Maps wird mit dem Veranstaltungsort geöffnet.",
      "directionsError": "Beim Öffnen der Wegbeschreibung ist ein Fehler aufgetreten.",
      "loadAttendeesError": "Wir konnten die bestätigten Teilnehmer nicht laden."
    },
    "readMore": "Mehr lesen",
    "readLess": "Weniger anzeigen",
    "spotsRemaining": "{count} Plätze frei"
  },
  "chats": {
    "title": "Chats",
    "activity": {
      "feedTitle": "Aktivität",
      "feedSubtitle": "Anfragen, Nachrichten und Verbindungen",
      "markAllRead": "Alle als gelesen markieren",
      "error": "Aktivität konnte nicht geladen werden.",
      "retry": "Erneut versuchen",
      "empty": "Du hast noch keine Aktivität",
      "emptyHint": "Verbindungsanfragen, Annahmen und Nachrichten erscheinen hier.",
      "exploreEvents": "Veranstaltungen entdecken",
      "someone": "Jemand",
      "newMessage": "Neue Nachricht",
      "sentRequest": "hat dir eine Anfrage gesendet",
      "requestSent": "Anfrage gesendet",
      "requestAccepted": "hat deine Anfrage angenommen"
    },
    "recentActivity": "Deine letzte Aktivität",
    "loading": "Laden...",
    "noChats": "Du hast noch keine Chats",
    "noChatsHint": "Melde dich für eine Veranstaltung an, um dich mit mehr Leuten zu verbinden und zu unterhalten",
    "tabs": {
      "activity": "Aktivität",
      "connections": "Verbindungen",
      "chats": "Chats"
    },
    "requests": {
      "title": "Anfragen",
      "allContacts": "Alle deine Kontakte",
      "favorites": "Favoriten",
      "sent": {
        "title": "Gesendete Anfragen",
        "pending": "ausstehende Anfrage",
        "pendingPlural": "ausstehende Anfragen",
        "waiting": "Warte auf Antwort",
        "cancel": "Abbrechen"
      },
      "received": {
        "title": "Verbindungsanfragen",
        "pending": "ausstehende Anfrage",
        "pendingPlural": "ausstehende Anfragen",
        "wantsToConnect": "Möchte sich mit dir verbinden",
        "accept": "Akzeptieren",
        "reject": "Ablehnen",
        "noPending": "Keine ausstehenden Anfragen"
      }
    },
    "contacts": {
      "noContacts": "Du hast keine verbundenen Kontakte",
      "noContactsHint": "Verbinde dich mit anderen Nutzern, um sie hier zu sehen",
      "removeFavorite": "Aus Favoriten entfernen",
      "addFavorite": "Zu Favoriten hinzufügen",
      "openChat": "Chat öffnen",
      "noFavorites": "Du hast keine Favoritenkontakte",
      "noFavoritesHint": "Markiere Kontakte als Favoriten, um sie hier zu sehen"
    },
    "connections": {
      "acceptSuccessTitle": "Verbindung angenommen",
      "acceptSuccessMessage": "Du kannst jetzt mit diesem Kontakt chatten.",
      "acceptErrorMessage": "Die Anfrage konnte nicht angenommen werden.",
      "rejectSuccessTitle": "Anfrage abgelehnt",
      "rejectSuccessMessage": "Du hast die Verbindungsanfrage abgelehnt.",
      "rejectErrorMessage": "Die Anfrage konnte nicht abgelehnt werden.",
      "cancelSuccessTitle": "Anfrage storniert",
      "cancelSuccessMessage": "Du hast die Verbindungsanfrage storniert.",
      "cancelErrorMessage": "Die Anfrage konnte nicht storniert werden.",
      "viewRequests": "Anfragen anzeigen",
      "dmBlockedTitle": "Verbindung erforderlich",
      "dmBlockedMessage": "Nimm die Verbindungsanfrage an, um zu chatten.",
      "alreadyPending": "Es gibt bereits eine ausstehende Anfrage zwischen euch.",
      "alreadyConnected": "Ihr seid bereits verbunden.",
      "cooldownActive": "Warte einen Moment, bevor du die Anfrage erneut sendest.",
      "rateLimited": "Zu viele Anfragen. Warte einen Moment und versuche es erneut."
    },
    "search": "Suchen oder neuen Chat starten",
    "noRecentChats": "Keine aktuellen Chats",
    "selectChat": "Wähle einen Chat",
    "selectChatHint": "Wähle eine Unterhaltung aus der Liste, um zu chatten",
    "myActivity": "Meine Aktivität",
    "allUsers": "Alle Nutzer",
    "recentActivityTitle": "Letzte Aktivität",
    "lastActions": "Letzte Aktionen",
    "noActivity": "Keine aktuelle Aktivität",
    "noActivityHint": "Deine Aktivität erscheint hier",
    "registeredUsers": "registrierte Nutzer",
    "loadingUsers": "Nutzer werden geladen...",
    "disconnect": "Trennen",
    "pending": "Ausstehend",
    "connect": "Verbinden",
    "chat": "Chat",
    "noUsers": "Keine registrierten Nutzer",
    "deleteConversation": {
      "title": "Unterhaltung löschen",
      "confirm": "Diese Unterhaltung mit {name} löschen?",
      "hint": "Sie wird aus deiner Liste ausgeblendet. Bei einer neuen Nachricht erscheint sie wieder.",
      "cancel": "Abbrechen",
      "deleting": "Wird gelöscht...",
      "delete": "Löschen",
      "button": "Chat löschen"
    },
    "errors": {
      "disconnectConfirm": "Bist du sicher, dass du diesen Nutzer trennen möchtest?",
      "hideError": "Die Unterhaltung konnte nicht ausgeblendet werden. Versuche es erneut.",
      "unexpectedError": "Unerwarteter Fehler beim Löschen des Chats. Versuche es erneut."
    },
    "dm": {
      "deleteError": "Chat konnte nicht gelöscht werden. Bitte erneut versuchen.",
      "deleteChat": "Chat löschen",
      "deleting": "Wird gelöscht..."
    }
  },
  "profile": {
    "loading": "Profil wird geladen...",
    "editPhoto": "Profilbild bearbeiten",
    "avatarUpdateError": "Profilbild konnte nicht gespeichert werden. Bitte erneut versuchen.",
    "avatarUploadError": "Foto konnte nicht hochgeladen werden. Bitte erneut versuchen.",
    "avatarCropTitle": "Foto anpassen",
    "avatarCropHint": "Ziehen und zoomen, um das Gesicht im Kreis auszurichten.",
    "avatarCropZoom": "Zoom",
    "avatarCropCancel": "Abbrechen",
    "avatarCropSave": "Foto verwenden",
    "avatarCropError": "Bild konnte nicht zugeschnitten werden. Bitte erneut versuchen.",
    "avatarCropInvalidType": "Bitte eine gültige Bilddatei auswählen.",
    "roles": {
      "admin": "Administrator",
      "user": "Nutzer"
    },
    "experience": {
      "beginner": "Anfänger",
      "intermediate": "Fortgeschritten",
      "advanced": "Erfahren",
      "expert": "Experte"
    },
    "whoAmI": {
      "student": "Student",
      "professional": "Berufstätig",
      "entrepreneur": "Unternehmer",
      "investor": "Investor",
      "mentor": "Mentor",
      "other": "Andere"
    },
    "goals": {
      "networking": "Networking",
      "learn": "Lernen",
      "opportunities": "Möglichkeiten",
      "mentorship": "Mentoring",
      "collaborate": "Zusammenarbeiten",
      "share": "Teilen",
      "personalBrand": "Persönliche Marke",
      "explore": "Erkunden"
    },
    "fields": {
      "email": "E-MAIL",
      "phone": "TELEFON",
      "birthday": "GEBURTSTAG",
      "location": "ORT"
    },
    "tabs": {
      "aboutMe": "Über mich",
      "networking": "Networking",
      "info": "Informationen",
      "interests": "Interessen",
      "social": "Soziale Netzwerke"
    },
    "completeness": {
      "label": "Profil ausgefüllt",
      "subtitle": "Vervollständige dein Profil für bessere Networking-Vorschläge.",
      "matchHint": "Profile mit mehr Informationen erhalten bessere Networking-Matches.",
      "completeProfile": "Profil vervollständigen",
      "completeNext": "Vervollständigen",
      "allDone": "Profil vollständig! Du erhältst die besten Matches.",
      "personalInfo": "Persönliche Daten",
      "interests": "Interessen",
      "eventObjective": "Veranstaltungsziel",
      "socialNetworks": "Soziale Netzwerke",
      "professionalExperience": "Berufserfahrung",
      "bio": "Bio",
      "networkingLevel": "Networking-Level",
      "hint_personal_info": "Füge deinen Vor- und Nachnamen hinzu",
      "hint_interests": "Füge deine beruflichen Interessen hinzu",
      "hint_event_objective": "Gib dein Ziel für die Veranstaltung an",
      "hint_social_networks": "Füge mindestens ein soziales Netzwerk hinzu",
      "hint_professional_experience": "Gib deine Rolle und Erfahrungsstufe an",
      "hint_bio": "Füge eine kurze Bio über dich hinzu"
    },
    "networking": {
      "title": "Networking",
      "seeking": "Suche Kontakt mit",
      "seekingTagInputPlaceholder": "Art der Personen eingeben, die du treffen möchtest, und Enter drücken (z.B. Gründer, Investoren, Entwickler)",
      "offering": "Was ich biete",
      "offeringTagInputPlaceholder": "Eingeben, was du anbieten kannst, und Enter drücken (z.B. Mentoring, Zusammenarbeit, Einstellung)",
      "eventObjective": "Veranstaltungsziel",
      "bioShort": "Bio (max. 200 Zeichen)",
      "bioShortPlaceholder": "z.B. Founder building AI products. Interested in meeting developers and investors.",
      "professionalKeywords": "Professionelle Tags",
      "seeking_investors": "Investoren",
      "seeking_founders": "Gründer",
      "seeking_developers": "Entwickler",
      "seeking_designers": "Designer",
      "seeking_marketing": "Marketing",
      "seeking_product_managers": "Product Managers",
      "offering_mentorship": "Mentoring",
      "offering_investment": "Investition",
      "offering_collaboration": "Zusammenarbeit",
      "offering_hiring": "Talent anheuern",
      "offering_finding_partners": "Partner suchen",
      "offering_sharing_knowledge": "Wissen teilen",
      "eventObjective_networking": "Networking",
      "eventObjective_finding_partners": "Partner suchen",
      "eventObjective_finding_clients": "Kunden suchen",
      "eventObjective_investment": "Investition",
      "eventObjective_learning": "Lernen",
      "eventObjective_recruiting": "Talent rekrutieren"
    },
    "matchScore": {
      "title": "Dein Profil passt zu",
      "subtitle": "Vervollständige dein Profil für bessere Vorschläge.",
      "empty": "Vervollständige den Networking-Bereich für Kompatibilitäten.",
      "developersAI": "KI-Entwickler",
      "foundersSaaS": "SaaS-Gründer",
      "investors": "Investoren",
      "developers": "Entwickler",
      "designers": "Designer",
      "marketing": "Marketing",
      "productManagers": "Product Managers",
      "fintech": "Fintech / Blockchain"
    },
    "aboutMe": {
      "title": "Über mich",
      "edit": "Bearbeiten",
      "biography": "Biografie",
      "biographyPlaceholder": "Beschreibe kurz, was du machst und wen du treffen möchtest (z.B. Gründer, der KI-Produkte entwickelt, interessiert daran, Entwickler und Investoren zu treffen).",
      "cancel": "Abbrechen",
      "save": "Speichern",
      "noBio": "Füge eine kurze Bio hinzu, damit andere Teilnehmer schnell verstehen, wer du bist.",
      "addBio": "Bio hinzufügen",
      "whatIDo": "Was ich mache",
      "noWhatIDo": "Fülle diesen Abschnitt aus, damit andere wissen, was du machst.",
      "role": "Rolle",
      "experience": "Erfahrung",
      "goals": "Ziele",
      "preferences": "Präferenzen"
    },
    "personalInfo": {
      "title": "Persönliche Informationen",
      "edit": "Bearbeiten",
      "firstName": "Vorname",
      "lastName": "Nachname",
      "birthDate": "Geburtsdatum",
      "phone": "Telefon",
      "email": "E-Mail-Adresse",
      "systemRole": "Systemrolle",
      "cancel": "Abbrechen",
      "save": "Speichern"
    },
    "address": {
      "title": "Adresse",
      "edit": "Bearbeiten",
      "city": "Stadt",
      "cancel": "Abbrechen",
      "save": "Speichern"
    },
    "interests": {
      "title": "Interessen",
      "edit": "Bearbeiten",
      "placeholder": "Innovation, Startups, Design...",
      "tagInputPlaceholder": "Interesse eingeben und Enter drücken (z.B. KI, Startups, Design)",
      "label": "Interessen",
      "cancel": "Abbrechen",
      "save": "Speichern",
      "general": "Allgemeine Interessen",
      "onboarding": "Onboarding-Interessen",
      "noInterests": "Du hast noch keine Interessen hinzugefügt."
    },
    "social": {
      "title": "Soziale Netzwerke",
      "edit": "Bearbeiten",
      "linkedin": "LinkedIn",
      "linkedinPlaceholder": "https://linkedin.com/in/nutzer",
      "twitter": "X (Twitter)",
      "twitterPlaceholder": "https://twitter.com/nutzer",
      "instagram": "Instagram",
      "instagramPlaceholder": "https://instagram.com/nutzer",
      "github": "GitHub",
      "githubPlaceholder": "https://github.com/nutzer",
      "facebook": "Facebook",
      "facebookPlaceholder": "https://facebook.com/nutzer",
      "youtube": "YouTube",
      "youtubePlaceholder": "https://youtube.com/kanal",
      "tiktok": "TikTok",
      "tiktokPlaceholder": "https://tiktok.com/@nutzer",
      "website": "Webseite",
      "websitePlaceholder": "https://meine-seite.de",
      "cancel": "Abbrechen",
      "save": "Speichern",
      "noSocial": "Du hast noch keine sozialen Netzwerke hinzugefügt.",
      "emptyHint": "Füge deine Netzwerke hinzu, damit andere Teilnehmer dich besser kennenlernen können.",
      "addSocialNetworks": "Soziale Netzwerke hinzufügen"
    },
    "errors": {
      "noChanges": "Keine Änderungen zum Speichern.",
      "updateError": "Fehler: Profil konnte nicht aktualisiert werden. Versuche es erneut.",
      "saveError": "Fehler: Beim Speichern des Profils ist ein Fehler aufgetreten. Versuche es erneut.",
      "avatarError": "Fehler beim Aktualisieren des Avatars"
    }
  },
  "activity": {
    "title": "Meine Aktivität",
    "subtitle": "Dein persönliches Dashboard für Veranstaltungen und aktuelle Aktivitäten",
    "loading": "Aktivität wird geladen...",
    "noActivity": "Du hast noch keine Aktivität",
    "noActivityHint": "Beginne damit, Veranstaltungen zu erkunden und dich anzumelden, um deine Aktivität hier zu sehen",
    "exploreEvents": "Veranstaltungen erkunden",
    "sentRequests": {
      "title": "Gesendete Anfragen",
      "pending": "ausstehende Anfrage",
      "pendingPlural": "ausstehende Anfragen",
      "waiting": "Warte auf Antwort",
      "cancel": "Abbrechen"
    },
    "receivedRequests": {
      "title": "Verbindungsanfragen",
      "pending": "ausstehende Anfrage",
      "pendingPlural": "ausstehende Anfragen",
      "wantsToConnect": "Möchte sich mit dir verbinden",
      "accept": "Akzeptieren",
      "reject": "Ablehnen"
    },
    "registeredEvents": {
      "title": "Registrierte Veranstaltungen",
      "event": "Veranstaltung",
      "events": "Veranstaltungen"
    },
    "recentActivity": {
      "title": "Letzte Aktivität",
      "subtitle": "Letzte Aktionen"
    }
  },
  "aboutUs": {
    "title": "Über uns",
    "hero": {
      "title": "Willkommen bei Biavent",
      "description": "Biavent ist eine Plattform, die entwickelt wurde, um Menschen mit gemeinsamen Interessen zu verbinden, professionelles Networking zu erleichtern und Möglichkeiten für persönliches und berufliches Wachstum zu schaffen."
    },
    "features": {
      "connections": {
        "title": "Verbindungen",
        "description": "Verbinde dich mit Fachleuten aus deiner Branche und erweitere dein Kontaktnetzwerk."
      },
      "events": {
        "title": "Veranstaltungen",
        "description": "Nimm an exklusiven Veranstaltungen teil und entdecke neue Wachstumsmöglichkeiten."
      },
      "community": {
        "title": "Community",
        "description": "Werde Teil einer aktiven Community von Menschen, die deine Interessen und Werte teilen."
      }
    }
  },
  "chat": {
    "event": {
      "loading": "Chat wird geladen...",
      "loadingMessages": "Nachrichten werden geladen...",
      "title": "Veranstaltungs-Chat",
      "noMessages": "Noch keine Nachrichten. Sei der Erste, der schreibt!",
      "user": "Nutzer",
      "placeholder": "Schreibe eine Nachricht...",
      "sending": "Wird gesendet...",
      "send": "Senden"
    },
    "dm": {
      "loading": "Chat wird geladen...",
      "loadingMessages": "Nachrichten werden geladen...",
      "userError": "Fehler: Aktueller Nutzer konnte nicht identifiziert werden",
      "user": "Nutzer",
      "noMessages": "Noch keine Nachrichten",
      "startConversation": "Starte die Unterhaltung!",
      "placeholder": "Schreibe an {name}...",
      "sending": "Wird gesendet...",
      "send": "Senden"
    }
  },
  "settings": {
    "title": "Einstellungen",
    "subtitle": "Verwalte deine Präferenzen",
    "appearance": {
      "title": "Erscheinungsbild",
      "theme": {
        "label": "Theme",
        "auto": "Automatisch (wie Gerät)",
        "light": "Hell",
        "dark": "Dunkel",
        "description": "Wähle, wie die App aussehen soll"
      }
    },
    "language": {
      "title": "Sprache",
      "label": "Sprache",
      "auto": "Automatisch (laut Gerät)",
      "description": "Wähle die Sprache der App",
      "detected": "Erkannt"
    },
    "appTour": {
      "title": "App-Tutorial",
      "description": "Sieh dir die geführte Tour der Hauptfunktionen erneut an.",
      "replay": "Tutorial erneut ansehen"
    },
    "notifications": {
      "title": "Benachrichtigungen",
      "subtitle": "Verwalte deine Push-Benachrichtigungseinstellungen"
    },
    "dataAndCache": {
      "title": "Daten & Cache",
      "description": "Aktualisiere gecachte Daten oder lade die App neu, um die neuesten Informationen zu sehen oder Ladeprobleme zu beheben.",
      "refreshData": "Daten aktualisieren",
      "clearAndReload": "Cache leeren und neu laden",
      "refreshSuccess": "Cache geleert. Neue Daten werden beim Navigieren geladen.",
      "reloading": "Wird neu geladen..."
    }
  },
  "votacion": {
    "title": "Hilf uns!",
    "subtitle": "Deine Meinung ist uns sehr wichtig. Teile deine Vorschläge, Ideen und Kommentare, um uns bei der Verbesserung zu helfen.",
    "form": {
      "loading": "Formular wird geladen...",
      "eventLabel": "Veranstaltung auswählen",
      "foundErrorsLabel": "Hast du Fehler gefunden?",
      "yes": "Ja",
      "no": "Nein",
      "errorDetailsLabel": "Falls ja, welche?",
      "errorDetailsPlaceholder": "Beschreibe die gefundenen Fehler, damit wir sie beheben können.",
      "commentLabel": "Möchtest du noch etwas zur Veranstaltung sagen? (optional)",
      "commentPlaceholder": "Konstruktive Kritik, dein Eindruck zur Veranstaltung oder alles, was du teilen möchtest.",
      "submit": "Feedback senden",
      "submitting": "Feedback wird gesendet..."
    },
    "messages": {
      "profileError": "Dein Profil konnte nicht geladen werden. Bitte versuche es erneut.",
      "selectEventRequired": "Bitte wähle eine Veranstaltung aus.",
      "selectErrorsRequired": "Bitte gib an, ob du Fehler gefunden hast.",
      "errorDetailsRequired": "Bitte beschreibe die gefundenen Fehler.",
      "submitError": "Dein Feedback konnte nicht gesendet werden. Bitte versuche es erneut.",
      "submitSuccess": "Danke, dass du uns hilfst besser zu werden. Dein Feedback wurde erfolgreich gesendet.",
      "noEligibleEvents": "Du hast noch keine verfügbaren Veranstaltungen zum Bewerten.",
      "alreadySentForEvent": "Für diese Veranstaltung hast du bereits Feedback gesendet.",
      "pickAnotherEvent": "Wähle eine andere Veranstaltung, wenn du weiteres Feedback senden möchtest."
    }
  },
  "calendar": {
    "confirmationTitle": "Anmeldung abgeschlossen!",
    "confirmationSubtitle": "Wir freuen uns auf dich bei {eventTitle}",
    "addToGoogleCalendar": "Zu Google Calendar hinzufügen",
    "addToAppleCalendar": "Zu Apple Calendar hinzufügen",
    "addToCalendar": "Zum Kalender hinzufügen",
    "hint": "Dies fügt das Event deinem Kalender hinzu. Du kannst es später bearbeiten.",
    "downloadICS": ".ics-Datei herunterladen"
  },
  "eventWizard": {
    "progressAria": "Wizard progress",
    "stepMeta": "Schritt {current} von {total}",
    "sections": {
      "identity": "Event-Identität",
      "visibility": "Sichtbarkeit",
      "configuration": "Konfiguration",
      "storytelling": "Storytelling",
      "when": "Wann",
      "formatAndPlace": "Format und Ort",
      "arrival": "Ankunft",
      "speakers": "Speaker",
      "agenda": "Agenda",
      "branding": "Branding",
      "review": "Zusammenfassung",
      "discovery": "Auffindbarkeit"
    },
    "steps": {
      "basic": "Basics",
      "location": "Location",
      "speakers": "Speakers",
      "agenda": "Agenda",
      "style": "Style",
      "review": "Review"
    },
    "nav": {
      "prev": "Back",
      "next": "Next",
      "cancel": "Cancel",
      "draft": "Save draft",
      "publish": "Create event",
      "saveChanges": "Save changes",
      "saving": "Saving..."
    },
    "loading": "Loading event data...",
    "previewLive": "Live preview",
    "previewPlatform": "Platform preview",
    "edit": "Edit",
    "step1": {
      "title": "The essentials of your event",
      "description": "Give your event an attractive title, an inspiring description, and choose its type.",
      "titleLabel": "Event title",
      "titlePlaceholder": "E.g. Biavent Networking Night Madrid",
      "titleHint": "Be clear and descriptive. A good title grabs your target audience instantly.",
      "visibilityLabel": "Public or private?",
      "visibilityPublic": "Public",
      "visibilityPrivate": "Private",
      "categoryLabel": "Main category",
      "eventTypeLabel": "Event type",
      "descriptionLabel": "Description",
      "descriptionPlaceholder": "Describe what attendees will learn, why your event is unique, and who it is for...",
      "highlightLabel": "Highlight quote",
      "highlightPlaceholder": "E.g. 'The biggest meetup for developers and investors of the year.'",
      "highlightHint": "A short, powerful phrase highlighted on the event landing page.",
      "tipTitle": "💡 Biavent tip",
      "tipText": "85% of registrations are driven by a structured description and a concise title. Define your target audience well!"
    },
    "step2": {
      "title": "Location and date",
      "description": "Set the date, time, and whether the event is in person or online.",
      "dateLabel": "Date",
      "timeLabel": "Time",
      "timePlaceholder": "E.g. 7:00 PM - 10:00 PM",
      "timezoneLabel": "Timezone",
      "locationLabel": "Location or link",
      "locationOnlineLabel": "Streaming link",
      "locationPlaceholder": "Street, city or link",
      "locationOnlinePlaceholder": "Zoom, Meet, YouTube...",
      "formatLabel": "Online or in person?",
      "formatInPerson": "In person",
      "formatOnline": "Online",
      "formatHybrid": "Hybrid",
      "mapButton": "Map",
      "venueLabel": "Venue name",
      "venuePlaceholder": "E.g. Main auditorium, Tech campus...",
      "arrivalLabel": "Additional arrival instructions",
      "arrivalPlaceholder": "Access, parking, floor, etc.",
      "mapsPreviewEmpty": "Enter an address to see the map preview",
      "capacityLabel": "Capacity limit",
      "capacityPlaceholder": "E.g. 100 — leave empty for unlimited",
      "capacityHint": "When capacity is reached, new registrations will be blocked automatically.",
      "latLabel": "Latitude (optional)",
      "lngLabel": "Longitude (optional)",
      "latPlaceholder": "E.g. 40.4167",
      "lngPlaceholder": "E.g. -3.7037"
    },
    "step3": {
      "title": "Your speakers",
      "description": "Introduce the speakers leading your sessions. Add role, bio, and photo.",
      "emptyTitle": "No speakers yet",
      "emptyText": "Will your event have speakers? Add them below. For informal networking you can skip this step.",
      "addSpeaker": "Add speaker",
      "nameLabel": "Name",
      "roleLabel": "Role",
      "bioLabel": "Short bio",
      "bioPlaceholder": "Short biography...",
      "avatarLabel": "Photo (URL)",
      "avatarPlaceholder": "https://...",
      "dragTitle": "Drag to reorder",
      "avatarUpload": "Upload photo",
      "avatarUploading": "Uploading...",
      "deleteSpeaker": "Remove"
    },
    "step4": {
      "title": "Program and agenda",
      "description": "Describe activities step by step so attendees can plan their day.",
      "emptyTitle": "Empty agenda",
      "emptyText": "Click «Add slot» to add activities (reception, talks, networking, etc.).",
      "addSlot": "Add slot",
      "startLabel": "Start",
      "endLabel": "Ende",
      "activityLabel": "Aktivität",
      "deleteSlot": "Slot entfernen",
      "slotTitlePlaceholder": "Networking, talk...",
      "activityFallback": "Activity"
    },
    "step5": {
      "title": "Style and branding",
      "description": "Upload cover images, logos, and choose colors for cards and buttons.",
      "bannerLabel": "Cover / banner image",
      "bannerUpload": "Upload main image (1200×630)",
      "bannerUploading": "Uploading image...",
      "bannerRemove": "Remove cover",
      "bannerUrlHint": "Or paste an image URL:",
      "logoLabel": "Company / organizer logo",
      "logoUpload": "Upload logo",
      "logoUploading": "Uploading logo...",
      "logoRemove": "Remove logo",
      "logoUrlHint": "Or paste logo URL:",
      "typographyLabel": "Typography",
      "paletteLabel": "Event color palette",
      "paletteHint": "Pick a brand combination or customize the accent color.",
      "primaryColor": "Primary color",
      "accentColor": "Accent color (buttons)",
      "previewBadge": "UPCOMING",
      "previewCtaFallback": "Register"
    },
    "step6": {
      "title": "Review and publish",
      "description": "Add contact info, social links, and preview your landing before saving.",
      "websiteLabel": "Official website",
      "emailLabel": "Contact email",
      "mapsLabel": "Google Maps link",
      "socialLabel": "Social media (optional)",
      "ctaLabel": "Call-to-action button text",
      "ctaPlaceholder": "E.g. Register for the event",
      "ctaHint": "Text shown on the main registration button.",
      "reviewBasic": "Basics",
      "reviewLocation": "Location",
      "reviewSpeakers": "Speakers",
      "reviewAgenda": "Agenda",
      "reviewStyle": "Style",
      "noTitle": "No title",
      "toDefine": "To be defined",
      "speakersCount": "{{count}} speakers",
      "agendaCount": "{{count}} slots",
      "visualIdentity": "Visual identity",
      "withCover": "With cover",
      "withoutCover": "No cover"
    },
    "eventNew": {
      "title": "Create new event",
      "subtitle": "Follow the steps to publish on Biavent. It will be saved as a draft until you publish."
    },
    "errors": {
      "fixBeforeContinue": "Fix the errors before continuing to the next step.",
      "loadEvent": "Error loading event",
      "titleRequiredSave": "Please enter a title for your event",
      "fixStepBeforePublish": "Please fix the fields in Step {{step}} before publishing.",
      "invalidImage": "Please select a valid image file (png, jpg, jpeg)",
      "imageTooLarge": "Image size cannot exceed 5 MB",
      "uploadFailed": "Error uploading image",
      "draftUpdated": "Draft updated successfully",
      "eventUpdated": "Event updated successfully",
      "draftSaved": "Draft saved. You can edit and publish it later",
      "eventCreated": "Congratulations! The event was created successfully",
      "saveFailed": "Error saving"
    },
    "accordion": {
      "advancedLocation": "Advanced location",
      "capacity": "Capacity",
      "contact": "Contact and social (optional)"
    },
    "font": {
      "system": "System (default)",
      "serif": "Classic serif",
      "modern": "Modern sans"
    },
    "social": {
      "linkedinPlaceholder": "Your company LinkedIn URL",
      "twitterPlaceholder": "Twitter / X URL",
      "instagramPlaceholder": "Instagram URL"
    }
  },
  "dashboardPremium": {
    "greeting": "Welcome back, {name}",
    "contextSummary": "You have {events} events this week and {pending} pending to publish",
    "searchPlaceholder": "Search events…",
    "createEvent": "Create event",
    "viewAnalytics": "Analytics",
    "trendVsPrevious": "vs previous period",
    "kpiActiveEvents": "Active events",
    "kpiActiveEventsFooter": "{scheduled} scheduled · {live} live now",
    "kpiUsers": "Registered users",
    "kpiUsersFooter": "+{new} new this period",
    "kpiOrganizations": "Partner companies",
    "kpiOrgsFooter": "+{new} new this period",
    "kpiConversion": "Conversion",
    "kpiConversionFooter": "Registrations / users",
    "activityTitle": "Activity summary",
    "range7d": "7D",
    "range30d": "30D",
    "range90d": "90D",
    "seriesRegistrations": "Registrations",
    "seriesPublications": "Publications",
    "seriesConnections": "Connections",
    "chartEmpty": "No activity in this period yet",
    "upcomingTitle": "Upcoming events",
    "noUpcoming": "No upcoming events",
    "emptyUpcomingHint": "Erstelle ein Event, um es hier zu sehen, sobald es geplant ist.",
    "badgeLive": "LIVE",
    "badgeScheduled": "SCHEDULED",
    "badgeDraft": "DRAFT",
    "editEvent": "Edit",
    "viewAllUpcoming": "View all ({count}) →",
    "quickActionsTitle": "Quick actions",
    "performanceTitle": "Recent performance",
    "perfTopRegistrations": "Top registrations",
    "perfLowAttendance": "Lowest attendance",
    "perfTopOrgs": "Most active companies",
    "perfPendingTasks": "Pending tasks",
    "perfEmpty": "No data yet",
    "perfTasksEmpty": "No pending tasks",
    "taskDrafts": "{count} draft events",
    "taskUnpublished": "{count} upcoming drafts",
    "growthTitle": "Growth tips",
    "aiLabel": "AI recommendation",
    "growthTipDrafts": "Draft events don't generate registrations until you publish them.",
    "growthRecDrafts": "You have {count} draft(s). Publish at least one to start capturing attendees.",
    "growthTipCover": "Events with a professional cover image tend to convert better.",
    "growthRecCover": "Events with a cover image convert up to {percent}% better on average.",
    "growthTipAttendance": "Attendance is below your platform average.",
    "growthRecAttendance": "Current attendance rate is {rate}%. Send reminders before the event starts.",
    "growthTipDefault": "Keep publishing and engaging attendees after each event.",
    "growthRecDefault": "Review analytics after each event to double down on what works.",
    "feedTitle": "Recent activity",
    "feedEmpty": "No recent activity",
    "feedRegistration": "New registration",
    "feedPlatform": "Platform",
    "feedPublished": "Event published",
    "feedNewOrg": "New company",
    "loadError": "Could not load dashboard",
    "actionNewEventDesc": "Launch a new event in minutes",
    "actionNewOrgDesc": "Onboard a new partner company",
    "actionUsersDesc": "Manage users and roles",
    "actionPermissionsDesc": "Organizers and access",
    "actionNotificationsDesc": "Reach your audience",
    "actionAttendeesDesc": "Registrations and check-in",
    "actionAnalyticsDesc": "Networking and engagement",
    "actionExportDesc": "Export attendee data",
    "headerStatEventsWeek": "events this week",
    "headerStatPending": "pending to publish"
  },
  "notFound": {
    "title": "Seite nicht gefunden",
    "message": "Die gesuchte Seite existiert nicht oder ist nicht mehr verfügbar.",
    "goHome": "Zu Events",
    "errorTitle": "Seite nicht gefunden",
    "errorMessage": "Diese Ansicht konnte nicht geladen werden.",
    "reload": "App neu laden"
  },
  "meetingQr": {
    "confirmTitle": "Treffen bestätigen",
    "confirmWith": "Mit {name}",
    "confirmCta": "Treffen bestätigen",
    "scanCta": "QR scannen",
    "scanTitle": "Treffen-QR scannen",
    "scanInstruction": "Richte die Kamera auf den QR-Code der anderen Person.",
    "scanHint": "Bitte die andere Person, diesen QR unter Verbindungen → QR scannen zu scannen.",
    "generating": "Sicherer QR wird erstellt…",
    "expiresIn": "Läuft ab in {time}",
    "confirmed": "Treffen bestätigt!",
    "expired": "Dieser QR ist abgelaufen",
    "generateAgain": "Neuen QR erstellen",
    "verifying": "Wird geprüft…",
    "scanAgain": "Erneut scannen",
    "back": "Zurück",
    "badgeConfirmed": "Treffen bestätigt",
    "errors": {
      "generic": "Etwas ist schiefgelaufen. Bitte erneut versuchen.",
      "invalid": "Ungültiger QR-Code",
      "expired": "Dieser QR ist abgelaufen",
      "alreadyUsed": "Dieser QR wurde bereits verwendet",
      "notTarget": "Dieser QR ist nicht für dich bestimmt",
      "self": "Du kannst kein Treffen mit dir selbst bestätigen",
      "noConnection": "Ihr müsst zuerst verbunden sein",
      "alreadyConfirmed": "Treffen bereits bestätigt",
      "noPriorChat": "Ihr müsst euch zuerst geschrieben haben",
      "rateLimited": "Zu viele Versuche. Bitte kurz warten.",
      "camera": "Kamerazugriff nicht möglich. Berechtigungen prüfen.",
      "cameraDenied": "Kameraberechtigung verweigert",
      "cameraUnavailable": "Keine Kamera auf diesem Gerät gefunden",
      "cameraInsecure": "Kamera erfordert eine sichere Verbindung (HTTPS)"
    },
    "cameraPermissionTitle": "Kamerazugriff erforderlich",
    "cameraPermissionBody": "Um den Treffen-QR zu scannen, benötigt Biavent Zugriff auf deine Kamera. Tippe auf die Schaltfläche, um ihn zu erlauben.",
    "allowCamera": "Kamera erlauben und scannen",
    "requestingCamera": "Kamera wird angefragt…",
    "cameraDeniedHint": "Kamerazugriff wurde blockiert. Erlaube die Kamera in den Browser- oder Geräteeinstellungen für Biavent und versuche es erneut.",
    "tryAgain": "Erneut versuchen"
  }
}
